// extracted by mini-css-extract-plugin
export default {"form":"PasswordInformationsBlock_form__KRjPk","passwordActions":"PasswordInformationsBlock_passwordActions__pwxcZ"};